module.exports = __webpack_public_path__ + "img/faux-carousel-blocks.ee79d04a.png";